// @flow

import {
  RECEIVE_AUTHENTICATED_USER,
} from './constants'

import {
  REMOVE_CREDENTIALS,
} from 'fc-auth'

type State = { authenticatedUser: ?number }

export function receiveAuthenticatedUser<S1: State, S2: $Shape<S1>> (state: S2, payload: number): S2 {
  return {
    ...state,
    authenticatedUser: payload,
  }
}

export function removeCredentials<S1: State, S2: $Shape<S1>> (state: S2): S2 {
  return {
    ...state,
    authenticatedUser: null,
  }
}

export default {
  [RECEIVE_AUTHENTICATED_USER]: receiveAuthenticatedUser,
  [REMOVE_CREDENTIALS]: removeCredentials,
}
